import createCache from '@emotion/cache';

export default function createEmotionCache() {
  let insertionPoint: HTMLElement | undefined;

  if (typeof document !== 'undefined') {
    const meta = document.querySelector(
      'meta[name="emotion-insertion-point"]'
    ) as HTMLElement | null;
    insertionPoint = meta ?? undefined;
  }

  return createCache({ key: 'mui', insertionPoint });
}
